<div mat-dialog-title>
  Eventos
  <div class="spacer"></div>
  <button mat-mini-fab color="warn" class="close-button" mat-dialog-close>
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>
<div mat-dialog-content>


  <mat-table [dataSource]="logs" class="w-100">

    <ng-container matColumnDef="eventDate">
      <mat-header-cell *matHeaderCellDef> Fecha </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.eventDate}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="eventTypeDescription">
      <mat-header-cell *matHeaderCellDef> Acción </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.eventTypeDescription}} </mat-cell>
    </ng-container>


    <ng-container matColumnDef="eventUser">
      <mat-header-cell *matHeaderCellDef> Usuario </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.eventUser}} </mat-cell>
    </ng-container>


    <ng-container matColumnDef="eventWorkstation">
      <mat-header-cell *matHeaderCellDef> Estación </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.eventWorkstation}} </mat-cell>
    </ng-container>


    <mat-header-row *matHeaderRowDef="['eventDate','eventTypeDescription','eventUser','eventWorkstation']; sticky:true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: ['eventDate','eventTypeDescription','eventUser','eventWorkstation'];"></mat-row>

  </mat-table>
</div>
<!--div mat-dialog-actions>
  <button mat-button mat-dialog-close>Cerrar</button>
</div-->